var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFolderIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 18,
    viewBox: "0 0 20 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.25 3.75001H10.3103L7.75 1.18969C7.61122 1.0498 7.44601 0.938889 7.26398 0.863407C7.08196 0.787925 6.88674 0.749378 6.68969 0.750008H1.75C1.35218 0.750008 0.970644 0.908043 0.68934 1.18935C0.408035 1.47065 0.25 1.85218 0.25 2.25001V15.8081C0.250496 16.1904 0.402567 16.5568 0.672863 16.8271C0.94316 17.0974 1.30962 17.2495 1.69188 17.25H18.3334C18.709 17.2495 19.069 17.1001 19.3346 16.8346C19.6001 16.569 19.7495 16.209 19.75 15.8334V5.25001C19.75 4.85218 19.592 4.47065 19.3107 4.18935C19.0294 3.90804 18.6478 3.75001 18.25 3.75001ZM1.75 2.25001H6.68969L8.18969 3.75001H1.75V2.25001ZM18.25 15.75H1.75V5.25001H18.25V15.75Z",
    fill: "#0181BB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFolderIcon);
export default __webpack_public_path__ + "static/media/folderIcon.a367c11abf6951f7cd561ebf9f7c30a5.svg";
export { ForwardRef as ReactComponent };